import {
    GET_VEHICLE_LIST,
    SET_VEHICLE,
    REMOVE_VEHICLE,
    GET_DEPARTMENTS,
    GET_AREAS,
    UPLOAD_FILE,
    GET_CATEGORIES,
    ADD_CATEGORY,
    SET_FILTER_VEHICLE_TYPE,
    GET_TEMPLATES,
    SET_ACTION
} from "./types";
import moment from "moment";
import firebase from "firebase/app";
export const getVehicles = () => {
    return dispatch => {
        dispatch({ type: GET_VEHICLE_LIST.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_VEHICLE_LIST.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/machines")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_VEHICLE_LIST.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_VEHICLE_LIST.FAIL });
        }
    };
};

export const getCategories = () => {
    return dispatch => {
        dispatch({ type: GET_CATEGORIES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_CATEGORIES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/vehicle_types")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_CATEGORIES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_CATEGORIES.FAIL });
        }
    };
};


export const uploadFile = (
    file = false,
    file_type = "machine_documents",
    successCallback,
    newAttachedFile
) => {
    return async dispatch => {
        dispatch({ type: UPLOAD_FILE.REQUEST });
        let newFileID = await getNewFileID();
        let fileExists = await doesFileExist(file.name, file_type);

        try {
            if (!fileExists) {
                let upload = firebase
                    .storage()
                    .ref(`file_manager/machine_documents`)
                    .child(file.name)
                    .put(file);

                upload.on(
                    "state_changed",
                    snapshot => {
                        let progress =
                            (snapshot.bytesTransferred / snapshot.totalBytes) *
                            100;

                        successCallback({
                            fileExists: false,
                            inProgress: true,
                            finished: false,
                            error: false,
                            progress: progress,
                            msg: "Upload is " + progress + "% done"
                        });
                    },
                    () => {
                        successCallback({
                            fileExists: false,
                            inProgress: false,
                            finished: false,
                            error: true,
                            msg: "Something went wrong with this upload!"
                        });
                        dispatch({ type: UPLOAD_FILE.FAIL });
                    },
                    () => {
                        upload.snapshot.ref.getDownloadURL().then(url => {
                            let newFile = {
                                file_id: newFileID,
                                file_name: file.name,
                                file_size: file.size,
                                file_url: url,
                                file_directory: file_type,
                                date_added: new moment().format(
                                    "DD-MM-YYYY hh:mm:ss"
                                ),
                                file_folder: file_type,
                                file_type: file.type
                            };
                            newAttachedFile({
                                file: file.name,
                                fileURL: url,
                                file_type,
                                file_id: newFileID
                            });
                            firebase
                                .database()
                                .ref(`/subjects/file_manager/machine_documents/${newFileID}/`)
                                .set(newFile)
                                .then(() => {
                                    dispatch({
                                        type: UPLOAD_FILE.SUCCESS
                                    });
                                    successCallback({
                                        fileExists: false,
                                        inProgress: false,
                                        finished: true,
                                        error: false,
                                        msg: "Success"
                                    });
                                });
                        });
                    }
                );
            } else {
                newAttachedFile(fileExists);
                successCallback({
                    fileExists: true,
                    inProgress: false,
                    finished: false,
                    error: false,
                    msg: "Success"
                });
                dispatch({ type: UPLOAD_FILE.FAIL });
            }
        } catch {
            dispatch({ type: UPLOAD_FILE.FAIL });
        }
    };
};
export const getNewFileID = async () => {
    let files = await getFiles();

    let newFileID;
    if (files) {
        let IDs = Object.keys(files).map(e => {
            return  Object.values(files[e]).map(f => {
                 return f.file_id
             })
         })
         let fileIDs =  Math.max(...[].concat(...IDs));
        newFileID = (Number(fileIDs) + 1).toString().padStart(6, "0");
        return newFileID;
    } else if (files == null) {
        newFileID = "000001";
        return newFileID;
    }
};
export const doesFileExist = async (name, directory) => {
    let files = await getFiles();

    let flag = false;
    if (files) {
        Object.keys(files).map(index => {
            if (
                files[index].file_name === name &&
                files[index].file_directory === directory
            )
                flag = {
                    file: files[index].file_name,
                    fileURL: files[index].file_url,
                    file_type: files[index].file_type,
                    file_id: files[index].file_id
                };
            return null;
        });
        return flag;
    } else if (files == null) {
        return false;
    }
};
export const getFiles = async () => {
    let files = await firebase
        .database()
        .ref(`subjects/file_manager`)
        .once("value");
    return files.val();
};
export const setVehicle = (
    vehicleUID = false,
    vehicle,
    profileBlob = false,
    newVehicle = false,
    QRfile
) => {
    return dispatch => {
        dispatch({ type: SET_VEHICLE.REQUEST });
        let key = vehicleUID === false ? vehicle.machine_reg : vehicleUID;

        try {
            firebase.auth().onAuthStateChanged(async user => {
                if (user) {
                    if (newVehicle)
                        await firebase
                            .storage()
                            .ref(
                                `/machine_photos/${vehicle.machine_reg}/qrcode_${vehicle.machine_reg}.png`
                            )
                            .putString(QRfile, "data_url")
                            .then(async snapshot => {
                                await snapshot.ref
                                    .getDownloadURL()
                                    .then(url => {
                                        vehicle.qr_code_url = url;
                                    });
                            });

                    if ((vehicle && profileBlob) !== false) {
                        firebase
                            .storage()
                            .ref(`/machine_photos/${vehicleUID}/photos`)
                            .put(profileBlob)
                            .then(snapshot => {
                                snapshot.ref.getDownloadURL().then(url => {
                                    vehicle.photo_url = url;
                                    firebase
                                        .database()
                                        .ref(`/subjects/machines/${key}`)
                                        .update({ profile: vehicle }, error => {
                                            if (error) {
                                                dispatch({
                                                    type: SET_VEHICLE.FAIL
                                                });
                                            } else
                                                dispatch({
                                                    type: SET_VEHICLE.SUCCESS
                                                });
                                        });
                                });
                            });
                    } else if (vehicle) {
                        firebase
                            .database()
                            .ref(`/subjects/machines/${key}`)
                            .update({ profile: vehicle }, error => {
                                if (error) {
                                    dispatch({ type: SET_VEHICLE.FAIL });
                                } else dispatch({ type: SET_VEHICLE.SUCCESS });
                            });
                    }
                } else {
                    dispatch({ type: SET_VEHICLE.FAIL });
                }
            });
        } catch {
            dispatch({ type: SET_VEHICLE.FAIL });
        }
    };
};
export const getDepartments = () => {
    return dispatch => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};

export const getAreas = () => {
    return dispatch => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};
export const removeVehicle = (vehicleUID = false) => {
    return dispatch => {
        dispatch({ type: REMOVE_VEHICLE.REQUEST });
        if (vehicleUID)
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref("/subjects/machines")
                            .child(vehicleUID)
                            .remove(error => {
                                if (error) {
                                    dispatch({ type: REMOVE_VEHICLE.FAIL });
                                } else {
                                    dispatch({ type: REMOVE_VEHICLE.SUCCESS });
                                }
                            });
                    } else {
                        dispatch({ type: REMOVE_VEHICLE.FAIL });
                    }
                });
            } catch (e) {
                dispatch({ type: REMOVE_VEHICLE.FAIL });
            }
        else dispatch({ type: REMOVE_VEHICLE.FAIL });
    };
};
export const uploadMultiImages = (regNo, file, callback) => {

    return async dispatch => {
        dispatch({ type: UPLOAD_FILE.REQUEST });
        
            let upload = firebase
                .storage()
                .ref(`vehicles/${regNo}`)
                .child(file.name)
                .put(file);

            upload.on(
                "state_changed",
                snapshot => {
                    let progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                    callback({
                        fileExists: false,
                        inProgress: true,
                        finished: false,
                        error: false,
                        progress: progress,
                        msg: "Upload is " + progress + "% done"
                    });
                },
                () => {
                    // Handle unsuccessful uploads
                    callback({
                        fileExists: false,
                        inProgress: false,
                        finished: false,
                        error: true,
                        msg: "Something went wrong with this upload!"
                    });
                    dispatch({ type: UPLOAD_FILE.FAIL });
                },
                () => {
                    //success
                    upload.snapshot.ref.getDownloadURL().then(url => {
                                callback({
                                    fileExists: false,
                                    inProgress: false,
                                    finished: true,
                                    error: false,
                                    msg: "Success",
                                    url
                                });
                            
                    });
                }
            );
        
        }
    };
    export const submitNewCategory = (label) => {
        return (dispatch) => {
            dispatch({ type: ADD_CATEGORY.REQUEST });
            let key = label.toLowerCase().replace(/ /g, "_");
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user === null) {
                        dispatch({ type: ADD_CATEGORY.FAIL });
                    } else {
                        firebase
                            .database()
                            .ref("/collections/vehicle_types/" + key)
                            .set(label);
                        dispatch({ type: ADD_CATEGORY.SUCCESS });
                    }
                });
            } catch (e) {
                dispatch({ type: ADD_CATEGORY.FAIL });
            }
        };
    };
    export const getTemplates = () => {
        return dispatch => {
            dispatch({ type: GET_TEMPLATES.REQUEST });
    
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({ type: GET_TEMPLATES.FAIL });
                    } else {
                        firebase
                            .database()
                            .ref("/collections/inspection_checklist_templates")
                            .on("value", snapshot => {
                                dispatch({
                                    type: GET_TEMPLATES.SUCCESS,
                                    payload: snapshot.val()
                                });
                            });
                    }
                });
            } catch (e) {
                dispatch({ type: GET_TEMPLATES.FAIL });
            }
        };
    };

    export const actionReset = (reg, livestatus, actiontaken, dateofaction, actionby, lastInspectionReceipt) => {
        return dispatch => {
            dispatch({ type: SET_ACTION.REQUEST });
    
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({ type: SET_ACTION.FAIL });
                    } else {
                        firebase
                            .database()
                            .ref(`/subjects/machines/${reg}/profile/action_reset`)
                            .update({live_status: livestatus, action_taken: actiontaken, date_of_action: dateofaction, action_by: actionby })
                            .then(() => {
                                firebase
                                    .database()
                                    .ref(`/subjects/machines/${reg}/receipts/${lastInspectionReceipt}`)
                                    .update({inspection_status: livestatus})
                                dispatch({
                                    type: SET_ACTION.SUCCESS
                                })
                            })
                    }
                });
            } catch (e) {
                dispatch({ type: SET_ACTION.FAIL });
            }
        };
    };
    export const setFilterVehicleType = (vehType = "all_categories") => {
        return (dispatch) => {
            dispatch({ type: SET_FILTER_VEHICLE_TYPE, payload: vehType });
        };
    };